import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import "./AppHome.css";
import "../Admin/Admin.css";

const BASE_URL = "https://gym-invoice-back.onrender.com";

export default function SuccessPaymentInvoice() {
  const { billNo } = useParams();
  const navigate = useNavigate();

  const [payment, setPayment] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const role = sessionStorage.getItem("userRole");
    if (!role) navigate("/");
  }, [navigate]);

  // ---------- LOAD PAYMENT BY BILL NO ----------
  useEffect(() => {
    if (!billNo) {
      setError("Missing Bill Number");
      setLoading(false);
      return;
    }

    const load = async () => {
      try {
        const res = await axios.get(`${BASE_URL}/api/payments/bill/${billNo}`);
        setPayment(res.data);
      } catch (err) {
        console.error("Error loading invoice:", err);
        setError("Failed to load invoice.");
      } finally {
        setLoading(false);
      }
    };

    load();
  }, [billNo]);

  // ---------- HELPERS ----------
  const fmt = (d) => (d ? new Date(d).toLocaleDateString() : "-");

const getBillCycle = () => {
  if (!payment?.date || !payment?.membershipType) {
    return ["-", "-"];
  }

  const planMonths = {
    "1 Month - Individual": 1,
    "1 Month Membership": 1,

    "3 Month - Individual": 3,
    "3 Month - Couple": 3,

    "6 Month - Individual": 6,
    "6 Month - Couple": 6,

    "12 Month - Individual": 12,
    "12 Month - Couple": 12,

    "Annual Membership - Individual": 12,
    "Annual Membership - Couple": 12,
  };

  const months = planMonths[payment.membershipType];

  if (!months) {
    console.error(
      "Unknown membership type:",
      payment.membershipType
    );

    return [fmt(payment.date), "-"];
  }

  // Use the stored LocalDate string directly
  const [year, month, day] = payment.date.split("-").map(Number);

  const fromDate = new Date(year, month - 1, day);

  // Calculate target month
  const targetMonth = fromDate.getMonth() + months;
  const targetYear = fromDate.getFullYear() + Math.floor(targetMonth / 12);
  const finalMonth = targetMonth % 12;

  // Prevent JavaScript date overflow
  const lastDayOfTargetMonth = new Date(
    targetYear,
    finalMonth + 1,
    0
  ).getDate();

  const finalDay = Math.min(day, lastDayOfTargetMonth);

  const toDate = new Date(
    targetYear,
    finalMonth,
    finalDay
  );

  return [fmt(fromDate), fmt(toDate)];
};

  const handlePrint = () => window.print();
  const handleBack = () => navigate(-1);

  const handleWhatsAppShare = () => {
    if (!payment) return;

    const [cycleFrom, cycleTo] = getBillCycle();
    const msg = `
🧾 *Life Fitness Partner – Payment Receipt*

*Bill No:* ${payment.billNo}
*Member:* ${payment.memberName}
*Membership:* ${payment.membershipType}

*Amount:* Rs. ${payment.amount}
*Paid On:* ${fmt(payment.payDate)}
*Bill Cycle:* ${cycleFrom} → ${cycleTo}

Thank you for your payment!
`;
    const url = "https://api.whatsapp.com/send?text=" + encodeURIComponent(msg);
    window.open(url, "_blank");
  };

  if (loading) return <div className="welcome-wrap">Loading...</div>;
  if (error) return <div className="welcome-wrap error">{error}</div>;
  if (!payment) return <div className="welcome-wrap">Invoice not found</div>;

  return (
    <div className="welcome-wrap">
      {/* Inline CSS for invoice styling */}
      <style>
        {`
          .welcome-card {
            max-width: 450px;
            max-height: 700px;
            margin: 10px auto;
            background: white;
            border-radius: 15px;
            box-shadow: 0 8px 25px rgba(0,0,0,0.15);
            padding: 25px;
            border: 8px solid #AA0000;
            font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
          }

          .welcome-header {
            display: flex;
            align-items: center;
            border-bottom: 2px dashed #eee;
            padding-bottom: 15px;
            margin-bottom:5px;
          }

          .gym-logo {
            width: 50px;
            height: 50px;
            border-radius: 50%;
            margin-right: 15px;
          }

          .gym-info h1 {
            margin: 0;
            color: #BC3F4A;
            font-size: 18px;
            font-weight:bold;
          }

          .gym-contact {
            font-size: 13px;
            color: black;
          }

          .welcome-titles {
            color: #333;
            text-align: center;
            margin-bottom: 2px;
          }

          .invoice-id {
            text-align: center;
            font-weight: bold;
            margin-bottom: 10px;
            color: #555;
          }

          .member-block {
            background: rgba(233,150,122,0.2);
            padding: 20px;
            border-radius: 12px;
            box-shadow: 0 3px 8px rgba(0,0,0,0.05);
          }

          .member-grid {
            display: grid;
            grid-template-columns: 1fr 1fr;
            row-gap: 10px;
            column-gap: 30px;
          }

          .member-item {
            display: flex;
            flex-direction: column;
          }

          .member-label {
            font-weight: bold;
            color: #B7410E;
            font-size: 14px;
            margin-bottom: 3px;
          }

          .member-value {
            font-size: 13px;
            color: black;
            font-weight: bold;
            padding-bottom: 4px;     /* space before the line */
            border-bottom: 1px solid #B7410E;  /* line color */
            margin-bottom: 8px;      /* space after the line */
            display: inline-block;
            width: 100%;
          }

          .bottom-row {
            margin-top: 10px;
            font-size: 13px;
            color: black;
          }

          .greeting {
            padding: 15px;
            border-radius: 10px;
            text-align: center;
            font-size: 13px;
            color:#BC3F4A;
            font-weight: 700;
          }

          .welcome-actions {
            display: flex;
            justify-content: center;
            gap: 10px;
            margin-top: 20px;
          }



          @media print {

            @page { size: A5 portrait; margin: 0;  }
            body { -webkit-print-color-adjust: exact !important; print-color-adjust: exact !important; margin: 0; }
            .no-print { display: none !important; }
              .welcome-wrap {
                min-height: auto !important;
                padding: 0 !important;
                    margin: 0;
                background: #fff !important;
              }
              .welcome-card {
                width: 100% !important;
                margin: 0 !important;
                box-shadow: none !important;
                padding: 10px !important;
                background: #fff !important;
              }
            .member-label { color:#B7410E; }

          }
        `}
      </style>

      {/* CARD */}
      <div className="welcome-card">
        {/* HEADER */}
        <div className="welcome-header">
          <img
            src={`${process.env.PUBLIC_URL}/Images/logo.jpeg`}
            alt="Gym Logo"
            className="gym-logo"
            onError={(e) => (e.target.style.display = "none")}
          />
          <div className="gym-info">
            <h1>LIFE FITNESS PARTNER</h1>
            <p className="gym-contact">
              No. 62/2, Horana Road, Colombo • +94-76 133 0825
            </p>
          </div>
        </div>

        {/* INVOICE TITLE */}
        <div className="welcome-body">
          <h2 className="welcome-titles">Payment Receipt</h2>
          <p className="invoice-id">
            Bill No: <strong>{payment.billNo}</strong>
          </p>

          {/* MEMBER INFO */}
          <div className="member-block">
            <div className="member-grid">
              <div className="member-item">
                <span className="member-label">Member Name:</span>
                <span className="member-value">{payment.memberName}</span>
              </div>
              <div className="member-item">
                <span className="member-label">Member ID:</span>
                <span className="member-value">{payment.memberId}</span>
              </div>
              <div className="member-item">
                <span className="member-label">Membership Type:</span>
                <span className="member-value">{payment.membershipType}</span>
              </div>

              <div className="member-item">
                <span className="member-label">Membership Period:</span>
                <span className="member-value">
                  {(() => {
                    const [from, to] = getBillCycle();
                    return `${from} ➝ ${to}`;
                  })()}
                </span>
              </div>

              <div className="member-item">
                              <span className="member-label">Payment Date:</span>
                              <span className="member-value">{fmt(payment.payDate)}</span>
                            </div>
              <div className="member-item">
                <span className="member-label">Amount Paid:</span>
                <span className="member-value">Rs. {payment.amount}</span>
              </div>
              <div className="member-item">
                <span className="member-label">Payment Method:</span>
                <span className="member-value">{payment.paymentMethod}</span>
              </div>
            </div>
          </div>

          {/* FOOTER NOTE */}
          <div className="bottom-row">
            <p><strong>Note:</strong> Payments are non-refundable.</p>
          </div>

          {/* GREETING */}
          <div className="greeting">
            Thank you for your support!<br />
            We appreciate your commitment to Life Fitness Partner. Keep up your fitness journey.
          </div>
        </div>

        {/* ACTION BUTTONS */}
        <div className="welcome-actions no-print">
          <button className="pay-button" onClick={handleBack}>← Back</button>
          <button className="pay-button" onClick={handleWhatsAppShare}>📲 Share</button>
          <button className="pay-button" onClick={handlePrint}>🖨️ Print</button>
        </div>
      </div>
    </div>
  );
}
